import React from 'react';
import { getBetDescription, parseHandicap } from '../data/utils';
import { BetslipSelectionsContext } from '../data/betslip/BetslipSelectionsConf';

export function isOddUnderMinValue(value) {
    return false;
}

export function useOddData(odd) {
    const betslipSelectionsContext = React.useContext(BetslipSelectionsContext);
    
    const betData = odd.betData;
    const betId = betData.cs != null ? betData.cs : betData.id;
    let desc = odd.desc;
    if (betData.hideHandicap) {
        desc = `${getBetDescription(betData, true, odd?.matchData?.sportRef)} ${odd.desc}`;
    } else if(odd.addBetDesc) {
        /*if (betData.handicap === 0 || HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP.includes(betData.tipoHandicap) || (isAsianHandicap(betData.id))) {
            desc = odd.desc;
        } else {
            desc = `${odd.desc} (${parseHandicap('', betData.handicap, betData.tipoHandicap, betData.eqs, betData.dia)})`;
        }*/
        desc = `${getBetDescription(betData, false, odd?.matchData?.sportRef)} ${odd.desc}`;

    }
    
    if (betData.dia?.length > 0) {
        const suffix = parseHandicap('', betData.handicap, betData.tipoHandicap, betData.eqs, betData.dia);
        if (suffix.length > 0 && suffix !== '0' && betData.tipoHandicap !== 48) {
            desc = `${desc} (${suffix})`;
        }
    }
    
    const selected = betslipSelectionsContext.isDrawSelected(odd.matchData.pal, odd.matchData.avv, betId, betData.handicap, odd.id);

    function addBet(e) {
        e.stopPropagation();

        if (odd.value == null) {
            return;
        }

        const matchData = odd.matchData;
        const timestamp = (typeof odd.matchData.timestamp === 'string') ? odd.matchData.timestamp : odd.matchData.timestampDB;
        let betDesc = betData.desc;
        let oddDesc = odd.desc;
        if (betData.hideHandicap === true) {
            betDesc = betData.aggDesc;
            oddDesc = desc; // quella della scommessa
        } 
        else{
            betDesc = getBetDescription(betData, false, matchData.sportRef);
        }
        
        betslipSelectionsContext.toggleSelectionBetslip(matchData.pal,
                                              matchData.avv,
                                              matchData.alias,
                                              matchData.desc,
                                              betData.isLive,
                                              betId,
                                              betData.handicap,
                                              betDesc,
                                              odd.id,
                                              oddDesc,
                                              odd.rawValue,
                                              betData.legabile,
                                              matchData.sportDesc,
                                              matchData.tournamentDesc,
                                              timestamp,
                                              matchData.sportRef,
                                              matchData.tournamentRef,
                                              betData.ming,
                                              betData.maxg);
    }

    return [desc, selected, addBet];
}
